export const SITE_TYPES = {
    INDOOR: 'indoor',
    OUTDOOR: 'outdoor'
};

export const INDOOR_TYPES = {
    AF2: 'af2',
    AF3: 'af3'
}